<template>
    <div>
        <span class="system-id">Case #<v-progress-circular v-if="progress" indeterminate size="16" width="1"
                                                           color="primary"></v-progress-circular>
            <span v-else>
                <span class="system-id-number" @click="handleSystemIdClick">{{systemId | NoEmpty}}</span>
            </span>
            <span v-if="overriddenSystemId && !modalVisible">
                <i class="fas fa-arrow-right ml-2 mr-2"></i>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <span v-on="on">{{overriddenSystemId}}</span>
                    </template>
                    <span>Case number will be changed after click on "Update" button</span>
                </v-tooltip>
            </span>
        </span>
        <v-dialog v-model="modalVisible" max-width="500" :persistent="true">
            <v-card>
                <v-card-title class="headline">Change case number</v-card-title>

                <v-card-text class="text--primary">
                    <v-form v-model="formValid">
                        <v-text-field label="New case number"
                                      v-model="overriddenSystemId"
                                      @input="handleOverriddenSystemIdInput"
                                      :rules="overriddenSystemIdRules"
                                      :error-messages="overriddenSystemIdErrorMessages"
                        ></v-text-field>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="error darken-1"
                            text
                            :disabled="!formValid"
                            @click="handleConfirmButtonClick"
                    >
                        Confirm
                    </v-btn>

                    <v-btn
                            color="gray darken-1"
                            text
                            @click="handleCancelButtonClick"
                    >
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import NoEmpty from '../../Filters/NoEmpty'
    import {isNumeric} from '../../../helpers/numbers'
    import {mapActions} from 'vuex'
    import _ from 'lodash'

    export default {
        name: "caseSystemId",
        props: {
            progress: Boolean,
            systemId: Number
        },
        filters: {
            NoEmpty
        },
        data() {
            return {
                formValid: false,
                modalVisible: false,
                overriddenSystemIdErrorMessages: [],
                overriddenSystemId: null,
                overriddenSystemIdRules: [
                    v => !!v || 'Enter new case number',
                    v => (v && _.toString(v).length <= 20) || 'Case number must not exceed 20 characters',
                    function (v) {
                        if (!v) {
                            return true
                        }

                        v = _.toString(v)

                        for (let vChar of v) {
                            if (!isNumeric(vChar)) {
                                return 'Case number must contains only digits'
                            }
                        }
                        return true
                    }
                ]
            }
        },
        watch: {
            systemId(newValue) {
                if (this.overriddenSystemId !== null && (parseInt(this.overriddenSystemId) === parseInt(newValue))) {
                    this.overriddenSystemId = null
                }
            }
        },
        methods: {
            ...mapActions('pgtCases', {
                checkOverriddenSystemId: 'checkOverriddenSystemId'
            }),
            handleSystemIdClick() {
                if (!this.systemId) {
                    return
                }

                this.modalVisible = true

                if (this.overriddenSystemId === null) {
                    this.overriddenSystemId = this.systemId
                }
            },
            async handleConfirmButtonClick() {
                this.$emit('overrideSystemId', null)

                const overriddenSystemId = parseInt(this.overriddenSystemId)
                if (overriddenSystemId === this.systemId) {
                    this.overriddenSystemId = null
                    this.clear()
                    return
                }

                let checkResult = await this.checkOverriddenSystemId(overriddenSystemId)

                if (checkResult === null) {
                    return
                }

                if (checkResult === false) {
                    this.overriddenSystemIdErrorMessages = [
                        'Case with this number is already exists'
                    ]

                    return
                }

                this.$emit('overrideSystemId', overriddenSystemId)
                this.clear()
            },
            handleCancelButtonClick() {
                this.overriddenSystemId = null
                this.modalVisible = false
            },
            handleOverriddenSystemIdInput() {
              if (this.overriddenSystemIdErrorMessages.length === 0) {
                  return
              }
              this.overriddenSystemIdErrorMessages = []
            },
            clear() {
                this.modalVisible = false
                this.overriddenSystemIdErrorMessages = []
            }
        }
    }
</script>

<style scoped>
    .system-id {
        font-size: 20px;
        font-weight: 500;
    }

    .system-id-number {
        border-bottom: 1px dashed;
        cursor: pointer;
    }

    .system-id-number-input {
        width: 70px;
        display: inline-block;
    }

    .system-id-number-input {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }
</style>

<style>
    .system-id-number-input input {
        text-align: left;
        font-size: 20px;
    }
</style>